import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { PartsGeneralSettingsComponent } from './parts-general-settings.component';
import { PartsGeneralSettingsRoutingModule } from './parts-general-settings-routing.module';

@NgModule({
  declarations: [PartsGeneralSettingsComponent],
  imports: [
    CommonModule,
    SharedModule,
    PartsGeneralSettingsRoutingModule,
    TranslateModule
  ],
  exports: [TranslateModule]
})
export class PartsGeneralSettingsModule { }
